// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SqlHelp_wrapper__2LGF-"};